/**
 * Custom Build of Core.js
 */

// All es5 features
require('core-js/es5');

// ES6
// Blacklisted - Symbol, Weakmap, Weakset, Math, Reflect, Typed Arrays
require('core-js/es6/object');
require('core-js/es6/function');

// Number Methods
require('core-js/fn/number/is-finite');
require('core-js/fn/number/is-nan');
require('core-js/fn/number/is-integer');
require('core-js/fn/number/is-finite');
require('core-js/fn/parse-float');
require('core-js/fn/parse-int');


// String Methods
require('core-js/fn/string/starts-with');
require('core-js/fn/string/ends-with');
require('core-js/fn/string/repeat');
require('core-js/fn/string/includes');
require('core-js/fn/string/trim');

// Date Methods
require('core-js/fn/date/to-string');
require('core-js/fn/date/now');

require('core-js/es6/array');
require('core-js/es6/regexp');
require('core-js/es6/promise');
require('core-js/es6/map');
require('core-js/es6/set');

// ES7
// Blacklisted - Reflect, String, Symbol, Math
require('core-js/fn/array/includes');
require('core-js/fn/object/values');
require('core-js/fn/object/entries');

// Timers
require('core-js/web/dom-collections');
